export const googleAnalyticsResource = `/analiticos-google`;
